export default "__VITE_ASSET__DG4Dr4W8__"